(() => {
  'use strict';
  const id = 'G-PH8Q0QME67';
  const adsId = 'AW-16694780972';
  const adsDestination = adsId + '/89qGCJ7lxagdEKzI2Jg-';
  if (window.Shopify?.designMode || (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') || new URLSearchParams(location.search).has('preview_theme_id')) return;
  if (window.kleverGoogleMeasurement) return;
  window.kleverGoogleMeasurement = true;
  let started = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const adsAllowed = () => allowed() && window.Shopify?.customerPrivacy?.marketingAllowed?.() === true && window.Shopify?.customerPrivacy?.saleOfDataAllowed?.() === true;
  const sent = new Set();
  window.dataLayer = window.dataLayer || [];
  function tag() { window.dataLayer.push(arguments); }
  tag('consent', 'default', {analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  const start = () => {
    window['ga-disable-' + id] = !allowed();
    tag('consent', 'update', {analytics_storage:allowed()?'granted':'denied',ad_storage:adsAllowed()?'granted':'denied',ad_user_data:adsAllowed()?'granted':'denied',ad_personalization:'denied'});
    if (!allowed() || started) return;
    started = true;
    tag('js', new Date());
    const config = {
      send_page_view:true,
      allow_google_signals:false,
      allow_ad_personalization_signals:false,
      page_location:location.origin + location.pathname,
      page_title:location.pathname === '/search' ? 'Búsqueda | Klever Shop' : document.title,
      page_referrer:''
    };
    try { const ref = new URL(document.referrer); config.page_referrer = ref.origin + ref.pathname; } catch (_) {}
    const params = new URLSearchParams(location.search);
    for (const [query,field] of [['utm_source','campaign_source'],['utm_medium','campaign_medium'],['utm_campaign','campaign_name'],['utm_content','campaign_content']]) {
      const value = params.get(query);
      if (value && /^[a-zA-Z0-9_-]{1,100}$/.test(value)) config[field] = value;
    }
    tag('config', id, config);
    tag('config', adsId, {...config,send_page_view:false,ads_data_redaction:true});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    document.head.appendChild(script);
  };
  const event = (name, data) => { if (started && allowed()) tag('event', name, {send_to:id,...data}); };
  document.addEventListener('visitorConsentCollected', start);
  // Fired by the cart only after the intake API confirms durable receipt.
  window.addEventListener('klever:quote-submitted', (e) => {
    const requestId = String(e.detail?.request_id || '').toLowerCase();
    const count = Number(e.detail?.item_count);
    if (!started || !allowed() || !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(requestId) || !Number.isInteger(count) || count < 1 || count > 50) return;
    const transactionId = 'ks_web_quote_' + requestId;
    const once = (destination, send) => {
      const key = 'klever.google.quote.' + destination + '.' + requestId;
      if (sent.has(key)) return;
      try { if (window.localStorage.getItem(key)) return; } catch (_) {}
      send();
      sent.add(key);
      try { window.localStorage.setItem(key, '1'); } catch (_) {}
    };
    once('ga4', () => event('generate_lead', {lead_type:'cotizacion_industrial',item_count:count}));
    if (adsAllowed()) once('ads', () => tag('event','conversion',{send_to:adsDestination,transaction_id:transactionId}));
  });
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest?.('a[href]');
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    if (/^tel:/i.test(href)) event('contact_click',{contact_method:'phone'});
    else if (/^mailto:/i.test(href)) event('contact_click',{contact_method:'email'});
    else if (/^https:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href)) event('contact_click',{contact_method:'whatsapp'});
    else if (/^https:\/\/portal\.klever-shop\.cl\/api\/public\/catalogs\/[^/?]+\/pdf(?:\?|$)/.test(href)) event('catalog_download',{document_type:'brand_catalog'});
  });
  if (window.Shopify?.customerPrivacy) start();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) start(); });
})();
